export default __webpack_public_path__ + "static/media/elevate-lav-poster-3.e07ce9cd.jpg";